window.fetchJson = async (endpoint, options = {}) => {
  // Force correct content-type and accept headers
  options.headers = options.headers ? options.headers : {};
  options.headers["content-type"] = "application/json";
  options.headers.accept = "application/json";

  const response = await fetch(endpoint, options);

  if (!response.ok) {
    throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
  }

  const json = await response.json();

  if (!json.success) {
    const error = json.error ? json.error : "generic";
    throw new Error(`Response Error: ${error}`);
  }

  if (json.data) {
    return json.data;
  }

  // Successful but no data
  return true;
};
